import React, { useState } from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
export function PartnerForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('submitting');
    const form = e.currentTarget;
    const formData = new FormData(form);
    // Convert FormData to a plain object for the email
    const data = {
      organization: formData.get('organization'),
      name: formData.get('name'),
      email: formData.get('email'),
      message: formData.get('message')
    };
    try {
      // Using Web3Forms - free service that sends to your email
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          access_key: 'YOUR_ACCESS_KEY_HERE',
          subject: 'New Partnership Inquiry - Good Father Project',
          from_name: data.name,
          ...data
        })
      });
      const result = await response.json();
      if (result.success) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }
  };
  return <section id="partner" className="py-24 bg-[#FAFAF8] border-t border-[#E5E5E0]" data-id="element-81">
      <Container className="max-w-3xl" data-id="element-82">
        <div className="text-center mb-12" data-id="element-83">
          <h2 className="text-4xl font-serif text-[#2D2D2D] mb-4" data-id="element-84">
            Partner With Us
          </h2>
          <p className="text-lg text-[#555555]" data-id="element-85">
            We invite schools, nonprofits, and community organizations to join
            us in this work. Please fill out the form below to start a
            conversation.
          </p>
        </div>

        {status === 'success' ? <div className="bg-[#F0F4F2] p-8 rounded-sm text-center border border-[#3D5A4C]" data-id="element-86">
            <h3 className="text-2xl font-serif text-[#3D5A4C] mb-4" data-id="element-87">
              Thank you for your interest.
            </h3>
            <p className="text-[#555555]" data-id="element-88">
              We have received your inquiry and will be in touch shortly to
              discuss how we can work together.
            </p>
            <Button variant="outline" className="mt-6" onClick={() => setStatus('idle')} data-id="element-89">
              Send Another Message
            </Button>
          </div> : status === 'error' ? <div className="bg-red-50 p-8 rounded-sm text-center border border-red-200" data-id="element-90">
            <h3 className="text-2xl font-serif text-red-700 mb-4" data-id="element-91">
              Something went wrong
            </h3>
            <p className="text-[#555555] mb-6" data-id="element-92">
              We couldn't send your message. Please try again or email us
              directly at travishellstrom@gmail.com
            </p>
            <Button variant="outline" onClick={() => setStatus('idle')} data-id="element-93">
              Try Again
            </Button>
          </div> : <form action="https://formsubmit.co/travishellstrom@gmail.com" method="POST" className="space-y-6 bg-white p-8 md:p-12 rounded-sm border border-[#E5E5E0]" data-id="element-94">
            {/* FormSubmit configuration */}
            <input type="hidden" name="_subject" value="New Partnership Inquiry - Good Father Project" data-id="element-95" />
            <input type="hidden" name="_captcha" value="false" data-id="element-96" />
            <input type="hidden" name="_template" value="table" data-id="element-97" />

            <div className="grid md:grid-cols-2 gap-6" data-id="element-98">
              <div className="space-y-2" data-id="element-99">
                <label htmlFor="orgName" className="block text-sm font-medium text-[#2D2D2D]" data-id="element-100">
                  Organization Name
                </label>
                <input type="text" id="orgName" name="Organization" required className="w-full px-4 py-3 bg-white border border-[#D1D1D1] rounded-sm focus:ring-2 focus:ring-[#3D5A4C] focus:border-transparent outline-none transition-all" placeholder="e.g. Lincoln Elementary School" data-id="element-101" />
              </div>
              <div className="space-y-2" data-id="element-102">
                <label htmlFor="contactName" className="block text-sm font-medium text-[#2D2D2D]" data-id="element-103">
                  Contact Name
                </label>
                <input type="text" id="contactName" name="Name" required className="w-full px-4 py-3 bg-white border border-[#D1D1D1] rounded-sm focus:ring-2 focus:ring-[#3D5A4C] focus:border-transparent outline-none transition-all" placeholder="Your full name" data-id="element-104" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-105">
              <label htmlFor="email" className="block text-sm font-medium text-[#2D2D2D]" data-id="element-106">
                Email Address
              </label>
              <input type="email" id="email" name="Email" required className="w-full px-4 py-3 bg-white border border-[#D1D1D1] rounded-sm focus:ring-2 focus:ring-[#3D5A4C] focus:border-transparent outline-none transition-all" placeholder="name@organization.org" data-id="element-107" />
            </div>

            <div className="space-y-2" data-id="element-108">
              <label htmlFor="message" className="block text-sm font-medium text-[#2D2D2D]" data-id="element-109">
                Message
              </label>
              <textarea id="message" name="Message" required rows={4} className="w-full px-4 py-3 bg-white border border-[#D1D1D1] rounded-sm focus:ring-2 focus:ring-[#3D5A4C] focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us about your organization and how you'd like to partner..." data-id="element-110" />
            </div>

            <div className="pt-4" data-id="element-111">
              <Button type="submit" className="w-full md:w-auto" data-id="element-112">
                Send Inquiry
              </Button>
            </div>
          </form>}
      </Container>
    </section>;
}